/**
 * Media
 */



export default function BOT_Media() {

	const selectors = {
		playButton: ".play-button",
		pauseButton: ".pause-button",
		youtube: "youtube-video",
		vimeo: "vimeo-video",
		video: ".background-video"
	};

	this.init = () => {
		triggerPlayButton();
	};

	const triggerPlayButton = () => {
		jQuery(selectors.playButton).on("click", function(){
			jQuery(this).toggleClass("d-none");
			jQuery(this).next().toggleClass("d-none");
			if (jQuery(this).hasClass(selectors.youtube)) {
				jQuery(this).siblings(selectors.video).each(function(){
					this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
				});
			} else if (jQuery(this).hasClass(selectors.vimeo)) {
				jQuery(this).siblings(selectors.video).each(function(){
					this.contentWindow.postMessage('{"method":"play"}', '*')
				});
			}
		})
		jQuery(selectors.pauseButton).on("click", function(){
			jQuery(this).toggleClass("d-none");
			jQuery(this).prev().toggleClass("d-none")
			if (jQuery(this).hasClass(selectors.youtube)) {
				jQuery(this).siblings(selectors.video).each(function(){
					this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
				});
			} else if (jQuery(this).hasClass(selectors.vimeo)) {
				jQuery(this).siblings(selectors.video).each(function(){
					this.contentWindow.postMessage('{"method":"pause"}', '*')
				});
			}
		})
	}
}
